import { SCANNER_PREFERENCE_KEY } from "./constants";

/**
 * Which TWAIN scanner this browser should use. Per-machine state, so it lives
 * in localStorage rather than in per-hotel config. Private-mode browsers throw
 * on localStorage access, so every call is guarded — a lost preference just
 * means the picker shows again, which is never worth crashing a check-in over.
 */
export function getPreferredScanner() {
  try {
    const stored = window.localStorage.getItem(SCANNER_PREFERENCE_KEY);
    const trimmed = stored?.trim();
    return trimmed ? trimmed : null;
  } catch {
    return null;
  }
}

export function setPreferredScanner(name) {
  try {
    window.localStorage.setItem(SCANNER_PREFERENCE_KEY, name);
  } catch {
    /* preference is an optimisation, not a requirement */
  }
}

export function clearPreferredScanner() {
  try {
    window.localStorage.removeItem(SCANNER_PREFERENCE_KEY);
  } catch {
    /* see above */
  }
}
